export default (state = null, action) => {
  switch (action.type) {
    case 'SET_GENERAL_ERROR':
      return action.payload

    case 'DISMISS_GENERAL_ERROR':
      return null

    default:
      return state
  }
}
